import React from "react";
import { Outlet } from "react-router-dom";
import ManagerSidebar from "../components/Sidebar/ManagerSidebar";

export default function ManagerLayout() {
  return (
    <div className="flex h-screen bg-gray-100">
      <ManagerSidebar />

      <main className="flex-1 p-6 overflow-y-auto">
        <Outlet /> {/* PAGE CONTENT SHOWS HERE */}
      </main>
    </div>
  );
}
